(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientTemplateDeleteController',PatientTemplateDeleteController);

    PatientTemplateDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientTemplate'];

    function PatientTemplateDeleteController($uibModalInstance, entity, PatientTemplate) {
        var vm = this;

        vm.patientTemplate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientTemplate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
